import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AxiosProvider, { IAxiosInfo } from "./components/AxiosProvider";
import { API_BASE_URL } from "./config/api";
import "./fonts.css";
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";

const publicUrl = process.env.PUBLIC_URL;
if (publicUrl === undefined) {
  throw new Error("PUBLIC_URL undefined.");
}
const buildAxiosInfo = (info: IAxiosInfo) => {
  return {
    ...info,
    config: {
      ...info.config,
      baseURL: `${API_BASE_URL}/`,
      withCredentials: true,
    },
  };
};

ReactDOM.render(
  <AxiosProvider buildAxiosInfo={buildAxiosInfo}>
    <BrowserRouter basename={publicUrl.replace(/.*\/\/[^/]*/, "")}>
      <App />
    </BrowserRouter>
  </AxiosProvider>,
  document.getElementById("root") as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx